/**
 * Custom SVG icons for Decideur use cases
 * Simple, modern, and brand-aligned designs
 */

interface IconProps {
  className?: string;
  color?: string;
}

// Icon for "Évaluer votre maturité numérique" - Magnifying glass with checklist
export function MaturityAuditIcon({ className = "w-16 h-16", color = "#55BC8C" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Checklist background */}
      <rect x="20" y="15" width="45" height="55" fill={color} rx="2" opacity="0.15" />
      {/* Checkmarks */}
      <polyline points="27,28 30,32 35,24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <polyline points="27,42 30,46 35,38" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <polyline points="27,56 30,60 35,52" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      {/* Lines next to checkmarks */}
      <line x1="40" y1="28" x2="58" y2="28" stroke={color} strokeWidth="2" strokeLinecap="round" opacity="0.5" />
      <line x1="40" y1="42" x2="58" y2="42" stroke={color} strokeWidth="2" strokeLinecap="round" opacity="0.5" />
      <line x1="40" y1="56" x2="58" y2="56" stroke={color} strokeWidth="2" strokeLinecap="round" opacity="0.5" />
      {/* Magnifying glass */}
      <circle cx="58" cy="58" r="14" fill="none" stroke={color} strokeWidth="3" />
      <line x1="68" y1="68" x2="80" y2="80" stroke={color} strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

// Icon for "Valoriser vos données" - Bar chart with trend arrow
export function DataValueIcon({ className = "w-16 h-16", color = "#55BC8C" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Bar chart */}
      <rect x="20" y="55" width="12" height="30" fill={color} rx="2" opacity="0.8" />
      <rect x="37" y="40" width="12" height="45" fill={color} rx="2" />
      <rect x="54" y="48" width="12" height="37" fill={color} rx="2" opacity="0.9" />
      <rect x="71" y="30" width="12" height="55" fill={color} rx="2" />
      {/* Trend line */}
      <polyline
        points="26,61 43,46 60,54 77,36"
        fill="none"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.6"
      />
      {/* Circle nodes on trend line */}
      <circle cx="26" cy="61" r="3" fill={color} />
      <circle cx="43" cy="46" r="3" fill={color} />
      <circle cx="60" cy="54" r="3" fill={color} />
      <circle cx="77" cy="36" r="3" fill={color} />
      {/* Arrow up */}
      <polyline
        points="70,20 77,13 84,20"
        fill="none"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line x1="77" y1="13" x2="77" y2="28" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}

// Icon for "Choisir les bons outils" - Target with tools
export function ToolSelectionIcon({ className = "w-16 h-16", color = "#55BC8C" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Target circles */}
      <circle cx="50" cy="50" r="35" fill="none" stroke={color} strokeWidth="2.5" opacity="0.3" />
      <circle cx="50" cy="50" r="25" fill="none" stroke={color} strokeWidth="2.5" opacity="0.5" />
      <circle cx="50" cy="50" r="15" fill="none" stroke={color} strokeWidth="2.5" opacity="0.7" />
      <circle cx="50" cy="50" r="6" fill={color} />
      {/* Arrow hitting target */}
      <line x1="72" y1="28" x2="54" y2="46" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
      <polyline
        points="72,28 68,26 70,22"
        fill={color}
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Checkmark on center */}
      <polyline
        points="45,50 48,54 56,44"
        fill="none"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
